import { render } from "./Developer.vue?vue&type=template&id=458ddf10&scoped=true"
import script from "./Developer.vue?vue&type=script&lang=js"
export * from "./Developer.vue?vue&type=script&lang=js"

import "./Developer.vue?vue&type=style&index=0&id=458ddf10&lang=css"
import "./Developer.vue?vue&type=style&index=1&id=458ddf10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458ddf10"]])

export default __exports__